// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let React = require("react");
let ReactGoogleMaps = require("@vis.gl/react-google-maps");

let APIProvider = {};

let Circle = {};

let GoogleMaps = {
  Circle: Circle
};

let $$Map = {};

let Marker = {};

function ReactGoogleMaps$Circle(props) {
  let strokeWeight = props.strokeWeight;
  let strokeOpacity = props.strokeOpacity;
  let strokeColor = props.strokeColor;
  let fillOpacity = props.fillOpacity;
  let fillColor = props.fillColor;
  let radius = props.radius;
  let center = props.center;
  let map = ReactGoogleMaps.useMap();
  React.useEffect(() => {
    if (map === null) {
      return;
    }
    let circle = new google.maps.Circle({
      map: map,
      center: center,
      radius: radius,
      fillColor: fillColor,
      fillOpacity: fillOpacity,
      strokeColor: strokeColor,
      strokeOpacity: strokeOpacity,
      strokeWeight: strokeWeight
    });
    return () => circle.setMap(null);
  }, [JSON.stringify({
      center: center,
      radius: radius,
      fillColor: fillColor,
      fillOpacity: fillOpacity,
      strokeColor: strokeColor,
      strokeOpacity: strokeOpacity,
      strokeWeight: strokeWeight
    })]);
  return null;
}

let Circle$1 = {
  make: ReactGoogleMaps$Circle
};

exports.APIProvider = APIProvider;
exports.GoogleMaps = GoogleMaps;
exports.$$Map = $$Map;
exports.Marker = Marker;
exports.Circle = Circle$1;
/* react Not a pure module */
